import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import { sendEmail, formatEmailBody } from '../../utils/emailService';
import { trackCallbackRequest, trackOtpVerification } from '../../utils/analytics';
import { getUtmPayloadForApi } from '../../utils/utm';
import axios from 'axios';
import './callbackpopup.css'

const Callbackpopup = ({cardItem, onClose, onSubmit, popupType }) => {
  const [name, setName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [nameError, setNameError] = useState('');
  const [mobileError, setMobileError] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [otpError, setOtpError] = useState('');
  const [generatedOtp, setGeneratedOtp] = useState('');
  const inputRefs = useRef([0,1,2,3,4,5].map(()=>React.createRef()));   
  const [showOtpField, setShowOtpField] = useState(false);
  const [cardItemValue] = useState(cardItem);
  const [popupTypeValue, setPopupTypeValue] = useState('userInfo');
  const [showPopupSubmit, setShowPopupSubmit] = useState(false);
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  // Generate random 6-digit OTP
  const generateOtp = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };

  const handleSubmit = async(e) => {
    // Validate the form fields before submission
    e.preventDefault();
    
    // Validate mobile number before proceeding
    if (!showOtpField) {
      if (mobileNumber.length !== 10) {
        setMobileError('Mobile number must be exactly 10 digits');
        return;
      }
      if (mobileNumber[0] === '0') {
        setMobileError('Mobile number cannot start with 0');
        return;
      }
      if (name.length < 3) {
        setNameError('Name must be at least 3 characters long');
        return;
      }
    }
    
    if(showOtpField){
        // Verify OTP first
        const enteredOtp = otp.join('');
        
        if (enteredOtp.length !== 6) {
          setOtpError('Please enter all 6 digits');
          return;
        }
        
        if (enteredOtp !== generatedOtp) {
          // In real implementation, verify OTP with backend
          // For now, show error for invalid OTP
          setOtpError('Invalid OTP. Please try again.');
          setOtp(['', '', '', '', '', '']);
          trackOtpVerification('callback_form', false);
          setTimeout(() => {
            inputRefs.current[0].current.focus();
          }, 100);
          return;
        }
        
        // Clear error on successful verification
        setOtpError('');
        trackOtpVerification('callback_form', true);
        
        // Verify OTP and send email + create callback request
        setIsSendingEmail(true);
        try {
          const emailBody = formatEmailBody({
            'Request Type': cardItemValue,
            'Name': name,
            'Mobile Number': mobileNumber,
            'Status': 'OTP Verified',
            'Submitted At': new Date().toLocaleString()
          }, 'callback');

          // Send email
          await sendEmail({
            subject: `New Callback Request: ${cardItemValue}`,
            body: emailBody,
            to: 'inspection@snageasy.in',
            from: 'inspection@snageasy.in'
          });

          // Create callback request in Firestore
          try {
            const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
            const response = await axios.post(
              `${API_BASE_URL}/api/callback-requests`,
              {
                customerName: name.trim(),
                customerMobile: mobileNumber.trim(),
                utm: getUtmPayloadForApi()
              },
              {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
            );
            console.log('✅ Callback request created successfully:', response.data);
          } catch (callbackError) {
            console.error('⚠️ Failed to create callback request in Firestore:', callbackError);
            // Don't fail the entire submission if Firestore creation fails
            // The email was already sent successfully
          }

          // Track callback request
          trackCallbackRequest(cardItemValue);

          setShowOtpField(false);
          setShowPopupSubmit(true);
          setPopupTypeValue('userInfo');
          setGeneratedOtp(''); // Clear generated OTP after successful verification
          setOtp(['', '', '', '', '', '']);
          setOtpError(''); // Clear any OTP errors
        } catch (error) {
          console.error('Failed to send email:', error);
          alert('Failed to submit request. Please try again.');
        } finally {
          setIsSendingEmail(false);
        }
    }
    else{
    // Generate random OTP when showing OTP field
    const newOtp = generateOtp();
    setGeneratedOtp(newOtp);
    
    // Log OTP for testing (remove in production)
    console.log('Generated OTP:', newOtp);
    
    setShowOtpField(true);
    setPopupTypeValue('otp');
    setOtpError(''); // Clear any previous OTP errors
    
    // Reset focus to first OTP input
    setTimeout(() => {
      inputRefs.current[0].current.focus();
    }, 100);
    }
    console.log('Form data submitted:', name, mobileNumber, cardItemValue);
    // const apiUrl = 'http://app-load-balancer-snageasy-2052419147.ap-south-1.elb.amazonaws.com/comms-layer/sms/snageasy/otp-signup';

    // try {
    //   // Make the API call using Axios
    //   const response = await axios.post(
    //     apiUrl,
    //     {
    //       mobile: mobileNumber,
    //       refId: mobileNumber,
    //       appId: 1,
    //       isOTP: true,
    //     }
    //   );

    //   if (response.status === 200) {
    //     // API call successful, update state to show OTP field
    //     setShowOtpField(true);
    //   } else {
    //     setShowOtpField(false);
    //     // Handle API error
    //     console.error('API call failed:', response.status, response.statusText);
    //   }
    // } catch (error) {
    //   // Handle network or other errors
    //   setShowOtpField(false);
    //   console.error('Error during API call:', error);
    // }
      // Handle form submission logic here
      //onSubmit({ name, mobileNumber });
      // Close the popup
      //onClose();

  };
  const editMobileClick = (event) => {
    event.preventDefault();
    setShowOtpField(false);
    setGeneratedOtp('');
    setOtp(['', '', '', '', '', '']);
    setOtpError('');
  }
  const handleNameChange = (value) => {
    const sanitizedValue = value.replace(/[^A-Za-z ]/g, '');
    setName(sanitizedValue);
    if (sanitizedValue.length < 3) {
      setNameError('Name must be at least 3 characters long');
    } else {
      setNameError('');
    }
  }
  const handleMobileChange = (value) => {
    // Only allow numbers and limit to 10 digits
    const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 10);
    
    // Prevent 0 as first digit
    if (sanitizedValue.length > 0 && sanitizedValue[0] === '0') {
      setMobileError('Mobile number cannot start with 0');
      return;
    }
    
    setMobileNumber(sanitizedValue);
    
    // Validate exactly 10 digits
    if (sanitizedValue.length > 0 && sanitizedValue.length !== 10) {
      setMobileError('Mobile number must be exactly 10 digits');
    } else if (sanitizedValue.length === 10) {
      setMobileError('');
    } else {
      setMobileError('');
    }
  }
  const handleInputChange = (index, e) => {
    const { value } = e.target;
    
    // Only allow numbers
    const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 1);

    // Update the state with the new value
    setOtp((prevValues) => {
      const newValues = [...prevValues];
      newValues[index] = sanitizedValue;
      return newValues;
    });

    // Clear error when user starts typing
    setOtpError('');

    // Shift focus to the next input field if not the last one
    if (sanitizedValue && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].current.focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    // Handle backspace to move to previous input
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1].current.focus();
    }
  };
  const closePopup = () => {    
    if(popupTypeValue === 'otp'){
        setPopupTypeValue('userInfo');
        setShowOtpField(false);
    }else{
        onClose();
    }   
  };


   const isSubmitDisabled = showOtpField? name.length<3 || mobileNumber.length!==10
   || otp[0].length<1 || otp[1].length<1 || otp[2].length<1 || otp[3].length<1 || otp[4].length<1 || otp[5].length<1
   : name.length<3 || mobileNumber.length!==10;
  
    const handleBackdropClick = (e) => {
      // Close popup only if clicking on the backdrop, not on the content
      if (e.target === e.currentTarget) {
        closePopup();
      }
    };

    return createPortal(
        <div className="sng__popup" onClick={handleBackdropClick}>
          <div className="sng__popup-content" onClick={(e) => e.stopPropagation()}>
            <div className="sng__popup-header">
              <span className="close" onClick={closePopup}>&times;</span>
              {!showPopupSubmit ? (
                <h2>{cardItemValue}</h2>
              ) : (
                <h2>Callback Request Submitted!</h2>
              )}
              {!showPopupSubmit && (
                <p>Get a personalized consultation for your property related needs</p>
              )}
            </div>
            
            <div className="sng__popup-form">
              {showPopupSubmit && !showOtpField ? ( 
                <div className="sng__popup-after-submit">
                  <p>Thank you for your interest in SnagEasy. We will get back to you shortly.</p>
                </div>
              ) : showOtpField && !showPopupSubmit ? (
                <>
                  <p>Enter the 6-digit OTP sent to your mobile number:</p>
                  <div className="otp-input-container">
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        type="text"
                        value={digit}
                        onChange={(e) => handleInputChange(index, e)}
                        onKeyDown={(e) => handleOtpKeyDown(index, e)}
                        maxLength="1"
                        ref={inputRefs.current[index]}
                        placeholder="0"
                        className={otpError ? 'error' : ''}
                      />
                    ))}
                  </div>
                  {otpError && <p className="error-message" style={{ color: '#ef4444', fontSize: '14px', marginTop: '8px', textAlign: 'center' }}>{otpError}</p>}
                  <p className="otp-hint">(Verifying You Are Human)</p>
                  {generatedOtp && (
                    <p className="otp-display" style={{
                      marginTop: '12px',
                      padding: '12px',
                      background: 'linear-gradient(135deg, #3F51B5 0%, #F47436 100%)',
                      color: 'white',
                      borderRadius: '8px',
                      textAlign: 'center',
                      fontSize: '18px',
                      fontWeight: '700',
                      letterSpacing: '4px',
                      fontFamily: 'monospace'
                    }}>
                      Your OTP: {generatedOtp}
                    </p>
                  )}
                  <div className="otp-input-container-mobil">
                    <p>Mobile No: {mobileNumber} <button type="button" className="edit-link" onClick={editMobileClick}>Edit Mobile</button></p>
                  </div>
                </>
              ) : (
                <>
                  <label htmlFor="name">Full Name</label>
                  <input 
                    type="text" 
                    id="name" 
                    value={name} 
                    onChange={(e) => handleNameChange(e.target.value)}
                    placeholder="Enter your full name"
                    className={nameError ? 'error' : ''}
                  />
                  {nameError && <p className="error-message">{nameError}</p>}
        
                  <label htmlFor="mobileNumber">Mobile Number</label>
                  <input 
                    type="tel" 
                    id="mobileNumber" 
                    value={mobileNumber} 
                    onChange={(e) => handleMobileChange(e.target.value)}
                    placeholder="Enter your 10-digit mobile number"
                    maxLength="10"
                    className={mobileError ? 'error' : ''}
                  />
                  {mobileError && <p className="error-message">{mobileError}</p>}
                </>
              )}
              
              {!showPopupSubmit && (
                <>
                  <button onClick={handleSubmit} disabled={isSubmitDisabled || isSendingEmail}>
                    {isSendingEmail ? 'Sending...' : showOtpField ? 'Verify OTP' : 'Get Callback'}
                  </button>
                  <div className="privacy-text">
                    <span>By clicking submit, you agree with our</span>
                    <div className="privacy-links">
                      <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                      <span> and </span>
                      <a href="/terms-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>,
        document.body
      );
  };
  
  export default Callbackpopup;